import Vue from "vue";
import Vuex from "vuex";
import { mapGetters, mapActions } from "vuex";
import * as types from "./mutation-types";
import Cardapio from "../services/cardapio";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
var ls = new SecureLS({ encodingType: "aes" });

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

const state = {
  nome: "",
  logado: false,
  mesa: "",
  serie: "",
  num_serie: "",
  date_token: "",
  funcionamento: "",
  loja: "",
  nome: "",
  cpf: "",
  email: "",
  telefone: "",
  total: 0,
  pagamentoPix: null,
  contrato: "vueX" + process.env.VUE_APP_CONTRATO,
  added: [],
  addedadi: [],
  all: [{ cd: "", nm: "", classe: "", ingredientes: "", vl: "", vl_promo: "" }],
  adi: [
    {
      cd: "",
      cd_prod: "",
      qtd: "",
      vl: "",
      vl_promo: "",
      tipo: "",
      nm: "",
      cd_sabor: "",
      ordem: "",
      obs: "",
      cd_prod_pai: "",
    },
  ],
};

// getters
const getters = {
  retornaNome: (state) => state.nome,
  retornaCPF: (state) => state.cpf,
  retornaEmail: (state) => state.email,
  retornaTelefone: (state) => state.telefone,
  retornaTotal: (state) => state.total,
  retornaLogado: (state) => state.logado,
  getPagamentoPix: (state) => state.pagamentoPix,
  getLoja: (state) => state.loja,
  allAdicionais: (state) => state.adi, // would need action/mutation if data fetched async
  allProducts: (state) => state.all, // would need action/mutation if data fetched async
  getNumberOfProducts: (state) => state.all,
  cartProducts: (state) => {
    //alert(JSON.stringify(state.added))
    //alert(JSON.stringify(state.addedadi))
    return state.added;
  },
};
// actions
const actions = {
  addToCart({ commit }, { product, adicionaispergunta, obs }) {
    //alert(JSON.stringify('Produto: '+product));
    //alert(JSON.stringify('Adicional: '+adicionaispergunta));
    //alert(JSON.stringify('Obs: '+obs));
    var dados = new Object();
    dados.produto = product;
    dados.adicionais = adicionaispergunta;
    dados.observacao = obs;
    //alert(JSON.stringify(dados.observacao));
    commit(types.ADD_TO_CART, {
      dados,
    });

    //alert(JSON.stringify(adicionaispergunta));
  },
  async fetchProducts({ commit, state }) {
    var loja = state.loja != "" && state.loja;
    var resposta = await Cardapio.listar(loja);
    commit(types.FETCH_PRODUCTS, resposta.data);
  },
  removeFromCart({ commit }, index) {
    commit(types.REMOVE_FROM_CART, {
      index,
    });
  },
  removeFromCartAd({ commit }, adicionaispergunta) {
    commit(types.REMOVE_FROM_CART_AD, {
      cd: adicionaispergunta.cd,
    });
  },
  menosqtd({ commit }, index) {
    commit(types.DECREMENTA_QUANTIDADE, {
      index,
    });
  },
  somarqtd({ commit }, index) {
    commit(types.INCREMENTA_QUANTIDADE, {
      index,
    });
  },
};
// mutations
const mutations = {
  setFuncionamento(state, funcionamento) {
    state.funcionamento = funcionamento;
  },
  setLogado(state, logado) {
    state.logado = logado;
  },
  setMesa(state, mesa) {
    state.mesa = mesa;
  },
  setSerie(state, serie) {
    state.serie = serie;
  },
  setNumSerie(state, num_serie) {
    state.num_serie = num_serie;
  },
  setDateToken(state, date_token) {
    state.date_token = date_token;
  },
  setNome(state, nome) {
    state.nome = nome;
  },
  setCPF(state, cpf) {
    state.cpf = cpf;
  },
  setEmail(state, email) {
    state.email = email;
  },
  setTelefone(state, telefone) {
    state.telefone = telefone;
  },
  setTotal(state, total) {
    state.total = total;
  },
  setPagamentoPix(state, pagamento) {
    state.pagamentoPix = pagamento;
  },
  setLoja(state, loja) {
    state.loja = loja;
  },
  setZera(state, zerado) {
    state.added = zerado;
    state.all = zerado;
    state.adi = zerado;
    state.addedadi = zerado;
  },

  [types.ADD_TO_CART](state, dados) {
		//alert('Dados: '+JSON.stringify(dados));//cd='5'

		/*alert('Tudo: '+JSON.stringify(dados.dados.produto));
		alert('Codigo: '+JSON.stringify(dados.dados.produto.cd));
		alert('Nome: '+JSON.stringify(dados.dados.produto.nm));
		*/
		//alert('Adicional: '+JSON.stringify(dados.dados.adicionais));
		//alert('Adicional: '+JSON.stringify(adicionaispergunta));//adicionaispergunta='undefined'   

		const cd = dados.dados.produto.cd;
		const nm = dados.dados.produto.nm;
		const classe = dados.dados.produto.classe;
		const ingredientes = dados.dados.produto.ingredientes;
		const adicionaispergunta = dados.dados.adicionais;
		const obs = dados.dados.observacao;
		const peso =dados.dados.produto.peso
		const unitario = dados.dados.produto.unitario;

		//alert('Obs: '+JSON.stringify(obs));
		//const obs = dados.dados.adicionais;
		//const serie = localStorage.getItem('serie');
		//const num_serie = localStorage.getItem('num_serie');
		//const mesa = localStorage.getItem('mesa');

		const record = state.added.find(p => p.cd === cd)

		var valortotaladicional = 0;

		adicionaispergunta.forEach((item,index) => {
			if(item.tipo == "PIZZA" && index == 0){
				valortotaladicional = valortotaladicional +parseFloat(item.vl)
			}else{
				valortotaladicional = (parseFloat(valortotaladicional) + parseInt(item.qtd)*parseFloat(item.vl)).toFixed(2);
			}

			//alert(JSON.stringify(item));
		})
		const vl = (parseFloat(dados.dados.produto.vl) + parseFloat(valortotaladicional)).toFixed(2);

		if (!record) {
			state.added.push({
				cd,
				nm,
				vl,
				classe,
				ingredientes,
				adicionaispergunta,
				obs,
				quantity: 1,
				peso,
				unitario
				//serie,
				//num_serie,
				//mesa,
			})
		} else {
			state.added.push({
				cd,
				nm,
				vl,
				classe,
				ingredientes,
				adicionaispergunta,
				obs,
				quantity: 1,
				peso,
				unitario
				//serie,
				//num_serie,
				//mesa,
			})
			//record.quantity++
		}
		//alert(JSON.stringify(state.added));
		//alert(JSON.stringify(record));
	},
  [types.FETCH_PRODUCTS](state, products, adicionaispergunta, obs) {
    state.all = products;
    state.adi = adicionaispergunta;
    state.adi = obs;
  },

  [types.FETCH_ADICIONAIS](state, adicionaispergunta, obs) {
    //state.adi = adicionais
    (state.adi = adicionaispergunta), (state.adi = obs);
  },
  [types.REMOVE_FROM_CART](state, { index }) {
    state.added.splice(index, 1);
    console.log(state.added);
  },
  [types.DECREMENTA_QUANTIDADE](state, { index }) {
    if (state.added[index].quantity >= "2") {
      state.added[index].quantity -= 1;
    } else {
      Swal.fire({
        title: "Obrigatório ter pelo menos um item desse produto.",
        confirmButtonColor: "#000000",
      });
    }
  },
  [types.INCREMENTA_QUANTIDADE](state, { index }) {
    //console.log('aqui',index)
    state.added[index].quantity += 1;
  },
};

// one store for entire application
export default new Vuex.Store({
  state,
  /* modules: {
		dataStore
	  }, */
  plugins: [
    createPersistedState({
      key: state.contrato,
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
  /* plugins: [createPersistedState({
		key: state.contrato
	}),dataState], */
  strict: debug,
  getters,
  actions,
  mutations,
});
